import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2e7wjxu6t: FaireProductEntity = {
  token: "p_z2e7wjxu6t",
  type: "product",
  name: "Keshi Pearl & Puka Shell Necklace",
  brandToken: "b_d5ty4bqhca",
  brandName: "Salty But Sweet",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/de024aa78643626b8bb44599b12d2b5e38e12ad82ed1823b38c02535b105d8fb.png",
  priceDollars: 27.53,
  description:
    "Dainty little puka shells and keshi white pearls dangle from a 1.4mm 14k gold filled cable chain.\nAvailable in 3 lengths.\n\n\n\n",
  tags: [],
  msrpDollars: 55.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T02:43:22.324Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
